import styled from 'styled-components';
import { Typography } from '../../global/theme';

const AlertContainer = styled.div`
  padding: var(--space-8);
  border-radius: var(--border-radius-8);
  gap: var(--space-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: slideIn 0.3s ease;
  background-color: var(--background-primary);
  box-shadow: var(--shadow-dropdown);
  color: var(--text-primary);
  margin-bottom: var(--space-10);
  position: relative;
  z-index: var(--z-index-modal);
  ${Typography.body_lg_medium}

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: var(--space-10);
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export { CloseButton, AlertContainer };
